import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { createAminReplyToUserForGeneralQuerey } from "../../../api/FAQ/Admin/GenralFAQ/createAdminReplyToUserForGenralQuery";
import { getGeneralFaqReplyByAdmin } from "../../../api/FAQ/Admin/GenralFAQ/getRepliedFaqByFaqId";
import { getFaqByFaqId } from "../../../api/FAQ/UserFaq/getFaqByFaqId";
import { useAuthContext } from "../../../hooks";
import AdminGeneralFaqSc from "./index.sc";

function Index() {
  const auth = useAuthContext();
  const params = useParams();
  const [genralFaq, setGenralFaq] = useState<any>([]);
  const fetchFaqByFaqId = async () => {
    await getFaqByFaqId(auth?.userInfo?.orgs[0]?.id, params?.faqId)
      .then((e) => {
        console.log(e);
        setGenralFaq(e);
      })
      .catch((e) => console.log(e));
  };
  const [personalResponse, setPersonalResponse] = useState<any[]>([]);

  const fetchOrgUserPersonalFaq = async () => {
    await getGeneralFaqReplyByAdmin(auth?.userInfo?.orgs[0]?.id, params?.faqId)
      .then((e) => {
        setPersonalResponse(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchFaqByFaqId();
    fetchOrgUserPersonalFaq();
  }, []);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const handleCreatePersonalResponse = async (e: any) => {
    console.debug("data > ", e);
    await createAminReplyToUserForGeneralQuerey(
      auth?.userInfo?.orgs[0]?.id,
      genralFaq[0]?.user_id,
      params?.faqId,
      {
        ...e,
        re_org_user_id: auth?.userInfo?.orgs_user_id[0],
      }
    )
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
  };
  console.log(auth?.userInfo?.orgs_user_id[0]);
  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
    await handleCreatePersonalResponse(e);
    reset();
  };
  console.log(genralFaq[0]?.user_id);
  return (
    <AdminGeneralFaqSc>
      <div className="container_reply">
        {genralFaq?.map((data: any) => {
          return (
            <>
              <div className="heading">
                <div className="member_name">
                  Employee Name{""}:{""}
                  <span style={{ fontSize: "15px", margin: "10px" }}>
                    {data?.name}
                  </span>
                </div>
                <div className="faq_type">
                  FAQ Type {""}:{data?.faq_type_name}
                </div>
              </div>
              <div className="query_content">{data?.quest}</div>
            </>
          );
        })}
        <label>Response</label>
        <div className="admin_reply_container">
          {personalResponse?.map((data: any) => {
            return (
              <>
                <div>{data?.response}</div>
              </>
            );
          })}
        </div>

        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <label>Reply </label>
            <textarea
              {...register("response", {
                required: {
                  value: true,
                  message: "This is required",
                },
              })}
            ></textarea>
            <div className="response_tab">
              <Button className="submit_button" type="submit">
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </AdminGeneralFaqSc>
  );
}

export default Index;
